module.exports = __webpack_public_path__ + "static/img/profile.25c84cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/profile.jpg
// module id = +rrE
// module chunks = 1